import { useMutation, gql } from "@apollo/client"
import { PROCESS_FIELDS } from "./useQueryOrganisationTemplates"

const CREATEPROCESS_MUTATION = gql`
  mutation CreateProcess(
    $name: String!
    $steps: [ProcessStepInput!]!
    $after: ScheduleDateInput
    $due: ScheduleDateInput
    $pinning: ProcessPinningInput
    $inactive: Boolean
    $repeat: ProcessRepetitionInput
    $notify: ProcessNotifyInput
    $users: [ID!]!
    $groups: [ID!]!
    $locations: [ID!]!
  ) {
    createProcess(
      name: $name
      steps: $steps
      after: $after
      due: $due
      pinning: $pinning
      inactive: $inactive
      repeat: $repeat
      notify: $notify
      users: $users
      groups: $groups
      locations: $locations
    ) {
      ${PROCESS_FIELDS}
    }
  }
`

const useMutationCreateProcess = () => useMutation(CREATEPROCESS_MUTATION)

export { useMutationCreateProcess }
